var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    id: "svg_5",
    height: 3.33334,
    width: 23,
    y: 5.66665,
    x: 0.41671,
    stroke: "#fff",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    id: "svg_6",
    height: 3.33334,
    width: 23,
    y: 10.66663,
    x: 0.41671,
    stroke: "#fff",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    id: "svg_3",
    height: 3.33334,
    width: 23,
    y: 15.71086,
    x: 0.41671,
    stroke: "#fff",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.da9910c18a26a2b44f669bbf6687d553.svg";
export { ForwardRef as ReactComponent };